import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Inbox, Users, MessageSquare, Settings, LogOut, BarChart3, Gift, Bot, Trophy, CreditCard, Package, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";

const items = [
  { to: "/staff/orders", icon: Inbox, label: "Pedidos", testid: "side-orders" },
  { to: "/staff/clients", icon: Users, label: "Clientes", testid: "side-clients" },
  { to: "/staff/stats", icon: BarChart3, label: "Estadísticas", testid: "side-stats" },
  { to: "/staff/promotions", icon: Gift, label: "Promociones", testid: "side-promotions" },
  { to: "/staff/raffles", icon: Trophy, label: "Sorteos", testid: "side-raffles" },
  { to: "/staff/payments", icon: CreditCard, label: "Cobros", testid: "side-payments" },
  { to: "/staff/budgets", icon: Calculator, label: "Presupuestos", testid: "side-budgets" },
  { to: "/staff/service-catalog", icon: Package, label: "Catálogo Comercial", testid: "side-service-catalog" },
  { to: "/staff/messages", icon: MessageSquare, label: "Consultas", testid: "side-messages" },
  { to: "/staff/ai-inbox", icon: Bot, label: "Bandeja IA", testid: "side-ai-inbox" },
  { to: "/staff/settings", icon: Settings, label: "Configuración", testid: "side-settings" },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="grid h-screen grid-cols-1 overflow-hidden md:grid-cols-[260px_1fr]">
      <aside className="hidden flex-col gap-3 overflow-y-auto bg-slate-900 p-5 text-white md:flex">
        <div className="mb-6 flex items-center gap-2">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#4d7c0f] font-black">K</span>
          <div>
            <div className="text-lg font-black leading-tight">KAPEI</div>
            <div className="text-xs text-slate-400">Panel interno</div>
          </div>
        </div>
        <nav className="flex flex-col gap-1">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to} to={it.to} end={it.to === "/staff/orders"}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-bold transition-colors ${
                    isActive ? "bg-[#4d7c0f] text-white" : "text-slate-300 hover:bg-slate-800"
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                {it.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="mt-auto rounded-lg bg-slate-800 p-3 text-xs">
          <div className="font-bold text-white">{user?.name}</div>
          <div className="truncate text-slate-400">{user?.email}</div>
          <Button
            data-testid="staff-logout"
            variant="ghost" size="sm"
            onClick={async () => { await logout(); navigate("/staff/login"); }}
            className="mt-2 w-full justify-start text-slate-300 hover:bg-slate-700 hover:text-white"
          >
            <LogOut className="mr-2 h-4 w-4" /> Cerrar sesión
          </Button>
        </div>
      </aside>
      <main className="overflow-y-auto bg-slate-50 p-6 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
